var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.222L9 1l8 6.222V17a1.778 1.778 0 01-1.778 1.778H2.778A1.778 1.778 0 011 17V7.222z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.333 18.778v-8.89h5.334v8.89",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNy4yMjIyMkw5IDFMMTcgNy4yMjIyMlYxN0MxNyAxNy40NzE1IDE2LjgxMjcgMTcuOTIzNyAxNi40NzkzIDE4LjI1NzFDMTYuMTQ1OSAxOC41OTA1IDE1LjY5MzcgMTguNzc3OCAxNS4yMjIyIDE4Ljc3NzhIMi43Nzc3OEMyLjMwNjI4IDE4Ljc3NzggMS44NTQxIDE4LjU5MDUgMS41MjA3IDE4LjI1NzFDMS4xODczIDE3LjkyMzcgMSAxNy40NzE1IDEgMTdWNy4yMjIyMloiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02LjMzMzMzIDE4Ljc3NzhWOS44ODg4OUgxMS42NjY3VjE4Ljc3NzgiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgIconHome as ReactComponent };